import * as tsx from 'vue-tsx-support';
import PreferenceManager from '@/components/PreferenceManager';
// @ts-expect-error This component is not yet in typescript.
import SnippetManager from '@/components/SnippetManager';
import UserInfo from '@/components/UserInfo';
import UserNotifications from '@/components/UserNotifications';
import UserTransactions from '@/components/UserTransactions';
import { GlobalPermissions as GPerm } from '@/permissions';
import { UserStore } from '@/store';
import * as utils from '@/utils';
import './style.less';
export default tsx.componentFactoryOf().create({
    name: 'sidebar-user-info',
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    data() {
        return {
            oldSbloc: null,
        };
    },
    computed: {
        /** @returns Whether we are currently viewing this component in student view. */
        isStudentViewEnabled() {
            return UserStore.studentView().tag === 'enabled';
        },
        /** @returns Whether the logged in user has the *global* permission to use snippets. */
        canUseSnippets() {
            return UserStore.hasTenantPermission()(GPerm.can_use_snippets, UserStore.tenantId());
        },
        /** @returns The rendered snippet manager if we need to render it for the current user. */
        snippetsNode() {
            return utils.ifOrEmpty(this.canUseSnippets, () => <SnippetManager />);
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        transactionsNode() {
            return utils.ifJustOrEmpty(UserStore.loggedInUser(), user => (<UserTransactions user={user}/>));
        },
        /** @returns The preferences node if we need to render it. */
        preferencesNode() {
            return (<b-card header="Preferences">
                    <PreferenceManager showLanguage={false} showWhitespace={false} showContextAmount={false} showInlineFeedback={false} showTabPreset={true} showWhitespacePreset={true}/>
                </b-card>);
        },
        /** @returns The rendered user info panel for the current user state. */
        bodyNode() {
            return utils.ifExpr(this.isStudentViewEnabled, () => <UserNotifications />, () => [
                this.preferencesNode,
                <UserInfo />,
                <UserNotifications />,
                this.snippetsNode,
                this.transactionsNode,
            ]);
        },
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    mounted() {
        tsx.emitOn(this, 'onLoading', undefined);
        this.oldSbloc = this.$router.getQuery('sbloc').extractNullable();
        if (this.oldSbloc === 'm') {
            this.oldSbloc = null;
        }
        this.$router.replace(this.getNewRoute('m'));
        // Most components should be loaded by now.
        utils.waitAtLeast(250, Promise.resolve()).then(() => {
            tsx.emitOn(this, 'onLoaded', undefined);
        });
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    destroyed() {
        this.$router.replace(this.getNewRoute(this.oldSbloc));
    },
    methods: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        getNewRoute(sbloc) {
            const query = { ...this.$route.query };
            if (sbloc != null) {
                query.sbloc = sbloc;
            }
            return { ...this.$route, query };
        },
    },
    /** @returns The rendered sidebar user info panel. */
    render() {
        return <div class="sidebar-user-info">{this.bodyNode}</div>;
    },
});
